/** */
import {
  ADD_MANY_WALLETLOGS_TO_STORE,
  ADD_ONE_WALLETLOG_TO_STORE,
  ADD_SEARCH_RESULTS_TO_STORE,
  LOAD_WALLETLOGS_TO_STORE,
  REM_ONE_WALLETLOG_FROM_STORE
} from '../actions/wallet-log';

export default (state = {}, action) => {
  const { type, payload } = action;
  let previous_state;
  switch (type) {
    case ADD_MANY_WALLETLOGS_TO_STORE:
      return {
        ...state,
        ...payload.reduce(
          (walletlogs, walletlog) => ({
            ...walletlogs,
            [walletlog.id]: walletlog
          }),

          {}
        )
      };

    case ADD_ONE_WALLETLOG_TO_STORE:
      return {
        ...state,
        [payload.id]: payload
      };
    case ADD_SEARCH_RESULTS_TO_STORE:
      return {
        ...payload.reduce(
          (walletlogs, walletlog) => ({
            ...walletlogs,
            [walletlog.id]: walletlog
          }),
          {}
        )
      };
    case LOAD_WALLETLOGS_TO_STORE:
      return {
        ...payload.reduce(
          (walletlogs, walletlog) => ({
            ...walletlogs,
            [walletlog.id]: walletlog
          }),
          {}
        )
      };
    case REM_ONE_WALLETLOG_FROM_STORE:
      previous_state = { ...state };
      delete previous_state[payload];
      return {
        ...previous_state
      };
    default:
      return state;
  }
};
